import { listToMapName } from '../FormSlave'
import type { FormWorker } from '../FormWorker'

export const fieldValidatorsToUnknown = (
    fieldValidators: FormWorker.InternalValidatorFields,
    toUnknownNames: string[]
) =>
    Object.values(fieldValidators)
        .filter(f => toUnknownNames.includes(f.name))
        .map((f): FormWorker.InternalValidatorField => ({ ...f, isValid: 'unknown', isValidating: false }))
        .reduce(listToMapName, fieldValidators)

export const fieldValidatorsReducer = (
    fieldValidatorsResult: FormWorker.InternalValidatorFields,
    action: FormWorker.ActionValidator
): FormWorker.InternalValidatorFields => {
    switch (action.type) {
        case 'starting':
            return {
                ...fieldValidatorsToUnknown(fieldValidatorsResult, action.payload.fieldsToReset),
                [action.payload.name]: {
                    name: action.payload.name,
                    isValid: 'unknown',
                    isValidating: true,
                },
            }
        case 'completed':
            return {
                ...fieldValidatorsResult,
                [action.payload.name]: action.payload,
            }
    }
}
